/**
 * Fanxcloud sections: Motion scroll-in (opacity + vertical slide), CSS + IO fallback.
 */
(async function initFanxcloudScrollMotion() {
  const collectRoots = () =>
    document.querySelectorAll(
      ".js-fanxcloud-scroll-motion[data-motion-on='true']"
    );

  const prefersReduced =
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  const revealAll = () => {
    collectRoots().forEach((root) => {
      root.querySelectorAll("[data-motion-scroll]").forEach((el) => {
        el.classList.add("is-inview");
      });
    });
  };

  if (prefersReduced) {
    revealAll();
    document.addEventListener("shopify:section:load", revealAll);
    return;
  }

  let motion = null;
  try {
    motion = await import("https://esm.sh/motion@11.15.0");
  } catch (_e) {
    motion = null;
  }

  const setupTarget = (root, el) => {
    if (el.dataset.motionInit === "1") return;
    el.dataset.motionInit = "1";

    const rawY = el.getAttribute("data-motion-y");
    const rootY = root.dataset.motionY;
    const startY =
      rawY == null || rawY === ""
        ? rootY == null || rootY === ""
          ? 20
          : Number(rootY)
        : Number(rawY);

    const duration = Number(root.dataset.motionDuration || "0.6") || 0.6;
    const amount = Number(root.dataset.motionAmount || "0.25") || 0.25;
    const delay = Number(el.getAttribute("data-motion-delay") || "0") || 0;

    if (motion && motion.inView && motion.animate) {
      motion.inView(
        el,
        () => {
          motion.animate(
            el,
            { opacity: [0, 1], y: [startY, 0] },
            {
              duration,
              delay,
              ease: [0.25, 0.1, 0.25, 1],
            }
          );
        },
        { once: true, amount }
      );
      return;
    }

    root.classList.add("fanxcloud-scroll-motion--fallback");
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-inview");
          io.unobserve(entry.target);
        });
      },
      { root: null, threshold: amount }
    );
    io.observe(el);
  };

  const attach = () => {
    collectRoots().forEach((root) => {
      root.querySelectorAll("[data-motion-scroll]").forEach((el) =>
        setupTarget(root, el)
      );
    });
  };

  attach();
  document.addEventListener("shopify:section:load", attach);
})();
